import Swiper from "swiper";
import "swiper/css";

export default class SecondaryServicesCards {
  static init() {
    document.querySelectorAll(".secondary-services-cards").forEach((section) => {
      const sliderEl = section.querySelector(".secondary-services-cards__slider");
      if (!sliderEl) return;

      new Swiper(sliderEl, {
        slidesPerView: "auto", // Default (mobile/tablet): relies on CSS calc()
        spaceBetween: 20,
        grabCursor: true,
        simulateTouch: true,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
        // breakpoints: {
        //   1025: {
        //     slidesPerView: 4,
        //   },
        // },
      });
    });
  }
}